import React, { Component } from "react";
import Tick from "./../asset/images/tick.svg";
import Cancel from "./../asset/images/cancel.svg";
import logout from "./../asset/images/logout.svg";
import CustomButton from "../components/CustomButton";
import OrderItem from "../components/OrderItem";
import { Form } from "react-bootstrap";
import { word } from "../words.js";
import { ImpulseSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nameValue: "",
      emailValue: "",
      emailError: "",
      mobileValue: "",
      contentDisabled: false,
      tabSelected: !this.props.showHistory,
      dataLoading: false,
      loading: true,
      ordersList: [],
    };

    this.inputHandleChange = this.inputHandleChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.getCookie = this.getCookie.bind(this);
    this.getOrders = this.getOrders.bind(this);

    this.nameInput = React.createRef();
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentDidMount() {
    this.setState({ mobileValue: this.getCookie("gomenu_user_mobile") }, () => {
      let data = {
        mobile: this.state.mobileValue,
        token: this.getCookie("gomenu_user_token"),
      };

      //console.log(data);

      this.setState({ contentDisabled: true });

      fetch("https://api.sepandplus.ontco.com/publicapi/readCustomerInfo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          //console.log(result);
          if (result.status === 200) {
            this.setState({
              nameValue: result.result[0].fullName
                ? result.result[0].fullName
                : "",
              emailValue: result.result[0].email ? result.result[0].email : "",
            });

            this.getOrders();
          }

          // this.setState({contentDisabled:false})
        })
        .catch((err) => {
          //console.log(err);
          this.setState({ contentDisabled: false });
        });
    });
  }

  getOrders() {
    let data = {
      mobile: this.state.mobileValue,
      token: this.getCookie("gomenu_user_token"),
      page: 1,
      count: 100,
      // languageId: this.props.currentLang.languageId,
      // status: "active",
    };

    this.setState({ contentDisabled: true });

    fetch("https://api.sepandplus.ontco.com/publicapi/findAllForCustomer", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let res = [...result.result];
          if (this.props.currentLang.tag === "en") {
            res.forEach((element) => {
              element.statusTitle = element.statusTitleEN;
            });
          }
          this.setState({ ordersList: res });
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }

        this.setState({ contentDisabled: false, loading: false }, () => {
          if (this.state.tabSelected) this.nameInput.current.focus();
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ contentDisabled: false });
      });
  }

  hideModal() {
    this.props.onCancel();
  }

  inputHandleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onConfirm();
    }
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  onConfirm() {
    if (this.state.emailValue) {
      if (!this.validateEmail(this.state.emailValue)) {
        this.setState({
          emailError: word[this.props.currentLang.tag]["emailError"],
          tabSelected: true,
        });
        return;
      } else {
        this.setState({ emailError: "" });
      }
    } else {
      this.setState({ emailError: "" });
    }

    let data = {
      mobile: this.state.mobileValue,
      token: this.getCookie("gomenu_user_token"),
      fullName: this.state.nameValue ? this.state.nameValue : "",
      email: this.state.emailValue ? this.state.emailValue : "",
    };

    this.setState({ contentDisabled: true });

    fetch("https://api.sepandplus.ontco.com/publicapi/editCustomerInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.status === 200) {
          // toast.success(word[this.state.currentLang.tag]['profileSuccess'], {
          //     position: toast.POSITION.BOTTOM_RIGHT,
          //     hideProgressBar:true,
          //     autoClose: 6000,
          //     toastClassName: 'toast'
          // });
          this.props.onCancel();
        } else {
          this.setState({ contentDisabled: false });
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        //console.log(err);
        this.setState({ contentDisabled: false });
      });
  }

  onAccountClick() {
    this.setState({ tabSelected: true });
  }

  onHistoryClick() {
    this.setState({ tabSelected: false });
  }

  onLogout() {
    this.props.onLogoutClick();
  }

  render() {
    if (!this.state.loading) {
      return (
        <div
          className={
            this.props.currentLang.direction === "rtl"
              ? "dialogBox IRANSansMobileBoldFont"
              : "dialogBox SFUIDisplayBoldFont"
          }
          style={{
            direction: this.props.currentLang.direction,
            maxWidth: "500px",
          }}
        >
          <div
            className="dialogContentContainer"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "fit-content",
              position: "relative",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="popupTitle">
              {word[this.props.currentLang.tag]["account"]}
            </div>
            <div className="popupSubTitle" style={{ marginBottom: "15px" }}>
              {this.state.tabSelected
                ? word[this.props.currentLang.tag]["accountText"]
                : word[this.props.currentLang.tag]["orderHistoryText"]}
            </div>

            <div className="profileTabsContainer">
              <div
                className={
                  this.state.tabSelected
                    ? "profileTab profileTabSelected"
                    : "profileTab profileTabUnSelected"
                }
                onClick={this.onAccountClick.bind(this)}
              >
                {word[this.props.currentLang.tag]["information"]}
              </div>
              <div
                className={
                  !this.state.tabSelected
                    ? "profileTab profileTabSelected"
                    : "profileTab profileTabUnSelected"
                }
                onClick={this.onHistoryClick.bind(this)}
              >
                {word[this.props.currentLang.tag]["ordersHistory"]}
              </div>
            </div>
            <div className="profileListContainer">
              {this.state.tabSelected && (
                <div
                  style={{
                    marginTop: "10px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <Form.Control
                    className={
                      this.props.currentLang.direction === "rtl"
                        ? "inputStyle2 IRANSansMobileFont"
                        : "inputStyle2 SFUIDisplayFont"
                    }
                    placeholder={word[this.props.currentLang.tag]["fullName"]}
                    type="text"
                    name="nameValue"
                    onChange={this.inputHandleChange}
                    value={this.state.nameValue}
                    disabled={this.state.contentDisabled}
                    onKeyPress={this.handleKeyPress.bind(this)}
                    ref={this.nameInput}
                  />

                  <div className="errorMessageContainer">
                    {/* {this.state.codeError} */}
                  </div>

                  <Form.Control
                    className={
                      this.state.emailError !== ""
                        ? this.props.currentLang.direction === "rtl"
                          ? "inputStyle2 inputStyle2Error IRANSansMobileFont"
                          : "inputStyle2 inputStyle2Error SFUIDisplayFont"
                        : this.props.currentLang.direction === "rtl"
                        ? "inputStyle2 IRANSansMobileFont"
                        : "inputStyle2 SFUIDisplayFont"
                    }
                    placeholder={word[this.props.currentLang.tag]["email"]}
                    type="text"
                    name="emailValue"
                    onChange={this.inputHandleChange}
                    value={this.state.emailValue}
                    disabled={this.state.contentDisabled}
                    onKeyPress={this.handleKeyPress.bind(this)}
                  />

                  <div className="errorMessageContainer">
                    {this.state.emailError}
                  </div>

                  <Form.Control
                    className={
                      this.props.currentLang.direction === "rtl"
                        ? "inputStyle2 IRANSansMobileFont"
                        : "inputStyle2 SFUIDisplayFont"
                    }
                    type="text"
                    name="mobileValue"
                    value={this.state.mobileValue}
                    disabled={true}
                  />

                  <div
                    style={{
                      flex: "1",
                      width: "50%",
                      minWidth: "150px",
                      marginTop: "20px",
                      direction: "ltr",
                    }}
                  >
                    <CustomButton
                      title={word[this.props.currentLang.tag]["logout"]}
                      disabled={this.state.mobileDisabled}
                      imgHeight={25}
                      imgWidth={20}
                      minHeight="35px"
                      img={logout}
                      onClick={this.onLogout.bind(this)}
                    />
                  </div>
                </div>
              )}

              {!this.state.tabSelected && (
                <div
                  style={{
                    overflowY: "auto",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    maxHeight: "250px",
                  }}
                >
                  {this.state.ordersList.map((item, i) => {
                    return (
                      <OrderItem
                        key={i}
                        item={item}
                        logo={
                          "https://api.sepandplus.ontco.com/api/public/" +
                          item.logo
                        }
                        datetime={item.createdAt}
                        items={item.items}
                        currentLang={this.props.currentLang}
                        onViewInvoiceClick={(hashId) => {
                          this.props.onViewInvoiceClick(hashId);
                        }}
                      />
                    );
                  })}
                </div>
              )}
              {/* {!this.state.tabSelected && <div style={{overflowY: 'auto',width:'100%',display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'center',maxHeight:'220px'}}>
                                
                                <OrderItem logo="https://seeklogo.com/images/F/flame-restaurant-logo-DE854716D8-seeklogo.com.png" title="Vanak Resturang" date="2020/08/01" time="21:19" descr="Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger" currentLang={this.props.currentLang}/>
                                <OrderItem logo="https://seeklogo.com/images/F/flame-restaurant-logo-DE854716D8-seeklogo.com.png" title="Vanak Resturang" date="2020/08/01" time="21:19" descr="Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger, Zinger Burger" currentLang={this.props.currentLang}/>
                            </div>} */}
            </div>
          </div>

          {/* {this.state.validationForm && <div className="loginLinks">
                        {this.state.showResend && <div onClick={this.onResendCode.bind(this)} className={this.props.currentLang.direction==='rtl'?'linkStyle IRANSansMobileBoldFont':'linkStyle SFUIDisplayBoldFont'} style={{fontSize:'14px',marginTop:'0px'}}>{word[this.props.currentLang.tag]['resendCode']}</div>}
                        <div onClick={this.onChangeNumber.bind(this)} className={this.props.currentLang.direction==='rtl'?'linkStyle IRANSansMobileBoldFont':'linkStyle SFUIDisplayBoldFont'} style={{fontSize:'14px',marginTop:'10px'}}>{word[this.props.currentLang.tag]['changeNumber']}</div>
                    </div>} */}

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "20px",
              alignItems: "center",
              direction: "ltr",
            }}
          >
            <div style={{ flex: "1" }}>
              <CustomButton
                title={word[this.props.currentLang.tag]["cancel"]}
                imgHeight={20}
                backColor="var(--black1)"
                imgWidth={20}
                minHeight="35px"
                img={Cancel}
                onClick={this.hideModal.bind(this)}
              />
            </div>
            <div style={{ minWidth: "5px" }} />
            <div style={{ flex: "1" }}>
              <CustomButton
                title={word[this.props.currentLang.tag]["confirm"]}
                disabled={this.state.mobileDisabled}
                imgHeight={20}
                imgWidth={20}
                minHeight="35px"
                img={Tick}
                onClick={this.onConfirm}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="dialogBox" style={{ maxWidth: "500px" }}>
          <div className="loadingStyle">
            <ImpulseSpinner
              size={30}
              frontColor="var(--brown1)"
              backColor="var(--gray1)"
              loading={true}
            />
          </div>
        </div>
      );
    }
  }
}
